import {WebsiteTag} from "./website-tag";

export class WebsiteTagMapper {

  public static map(data: any): WebsiteTag {
    let websiteTag: WebsiteTag = new WebsiteTag();
    websiteTag.id = typeof data.id === 'number' ? parseInt(data.id, 10) : data.id;
    websiteTag.title = data.title;
    websiteTag.clientId = data.client_id;
    websiteTag.domains = data.domains;
    return websiteTag;
  }
}
